<template> 
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando">  
                <div class="row mb-10 mt-5" >  
                    <div class="col-12 col-sm-6 col-lg-6 mb-5"> 
                        <div class="form-group"> 
                            <label for="descricao" class="form-check-label">Status:</label> 
                            <Multiselect v-model="status_id" :options="status_select" :searchable="true" :disabled="!hasPermissaoEditar || !editando"></Multiselect> 
                        </div>
                    </div>  
                    <div class="col-12 col-sm-6 col-lg-6 mb-5"> 
                        <div class="form-group"> 
                            <label for="descricao" class="form-check-label">Data da publicação:</label>   
                            <input required type="date"  name="dataPublicacao" class="form-control" v-model="dataPublicacao" :disabled="!hasPermissaoEditar || !editando"  >  
                        </div>
                    </div>   
                    <div class="col-12 col-sm-6 col-lg-6 mb-5" > 
                        <div class="form-group"> 
                            <label for="descricao" class="form-check-label">Documento da Publicação:</label>   
                            <input required type="text"  name="" class="form-control" v-model="docPublicacao" :disabled="!hasPermissaoEditar || !editando"   >  
                        </div>
                    </div> 
                    <div class="col-12 col-sm-6 col-lg-6 mb-5" > 
                        <div class="form-group"> 
                            <label for="observacao" class="form-check-label">Observação:</label>   
                            <input required type="text"  name="" class="form-control" v-model="observacao" :disabled="!hasPermissaoEditar || !editando"  >  
                        </div>
                    </div> 
                    <div class="col-12 col-sm-6 col-lg-6 mb-5" v-if="status_id == 6"> 
                        <div class="form-group"> 
                            <label for="descricao" class="form-check-label">Média Final:</label>   
                            <input required type="number" name="mediaFinal" class="form-control" v-model="mediaFinal" :disabled="!hasPermissaoEditar || !editando"  >  
                        </div>
                    </div> 
                    <div class="col-12 col-sm-6 col-lg-6 mb-5" v-if="status_id == 6"> 
                        <div class="form-group"> 
                            <label for="descricao" class="form-check-label">Data da aprovação:</label>   
                            <input required type="date" name="dataAprovado" class="form-control" v-model="dataAprovado" :disabled="!hasPermissaoEditar || !editando"   >  
                        </div>
                    </div>       
                </div>    
                <div class="modal-footer" v-if="hasPermissaoEditar" > 
                    
                    <button class="btn btn-pmes-danger  me-3" v-if="editando" @click="editando = false">  
                        <span class="menu-icon">
                            <i class="fas fa-xmark fa-2x bi fs-2x" ></i> 
                        </span> Cancelar  
                    </button>  
                    <BotaoSalvar  @click="AlterarAluno" :processando="processando" v-if="editando"></BotaoSalvar> 
                     
                    <button class="btn py-3 btn-light me-3" v-if="!editando" @click="editando = true">  
                        <span class="menu-icon">
                            <i class="fas fa-edit fa-2x bi fs-2x" ></i> 
                        </span> Editar  
                    </button>  
                    
                </div>   
            </CardRh>
        </div>
    </div>
 
</template>

<script lang="ts">  
    import Multiselect from '@vueform/multiselect'
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue'; 
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import MatriculaService from   "@/service/v1/sigap/MatriculaService"   
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth');   


    @Options({
        name: "AlterarStatusMatricula",
        components: {  CardRh, Multiselect , BotaoSalvar },   
        emits: [ 'matricula-alterado'],  
    }) 
    export default class AlterarStatusMatricula extends Vue { 
        
        @Prop( ) readonly matricula!: any  
        
        @authStore.Getter
		public perfis!: any 

        public service = new MatriculaService();  
        
        public identificador = 1 ;   
        public status_id: any = 1
        public status: any = null;

        public observacao: any = null ;
        public dataPublicacao: any = null ;
        public dataAprovado: any = null ;
        public docPublicacao: any = null ;
        public mediaFinal: any = null ;
        
        public processando = false ;
        public editando = false ;

        @Watch('matricula')
		dadosAtualizado(newVal: string) { 
            this.identificador++; 
		} 
         
        created(){    
            this.getStatus();  
            this.status_id = this.matricula.status.id;
            this.dataPublicacao = SiteUtils.formatDataToPadrao(this.matricula.dataPublicacao)
            this.dataAprovado = SiteUtils.formatDataToPadrao(this.matricula.dataAprovado)
            this.docPublicacao = this.matricula.docPublicacao;
            this.mediaFinal = this.matricula.mediaFinal;
            this.observacao = this.matricula.observacao;
        }


        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
        }
 
        get hasPermissaoEditar( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }

        
        get hasAdmin( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin  ] ,  this.perfis); 
        }

        get status_select(){
            if(this.status){
                return this.status.map((item) => { return { value:  item.id , label: item.nome } });   
            }
            return null;
        }

        public getStatus(){   
            this.processando = true ; 
            this.service.getStatus(    ) 
            .then(response => {   
                this.status =  JSON.parse(JSON.stringify( response ));   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 
 
        public AlterarAluno() {
            if( this.processando  ||  !this.hasPermissaoEditar  ){
                return;
            }
            this.processando = true ;   
            let dados: any = {
                id: this.matricula.id , 
                status: this.status_id , 
                dataPublicacao: this.dataPublicacao  ,
                observacao: this.observacao  ,
                docPublicacao: this.docPublicacao, 
            } 
            if(this.status_id == 6 ){
                if(this.matricula.isPendAcadProc || this.matricula.isPendAcadSaude){
                    SiteUtils.toastErro('Não é possivel aprovar o aluno com Pendências' , "" );
                    this.processando = false ;
                    return;
                }
                dados.mediaFinal= this.mediaFinal;
                dados.dataAprovado=  this.dataAprovado;
            }  
            this.service.AlterarAluno( this.matricula.id ,dados )
            .then(response => { 
                this.$emit("matricula-alterado", response);
                this.editando = false;
                this.processando = false ; 
            })
            .catch(errors => {
                this.processando = false ;
            });
        }
 
    } 
</script> 